export const FollowUpStatus = {
  Todo: 0,
  FollowUp: 1,
  Done: 2
};